var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('InputText',{attrs:{"id":"name","name":"name","form":_vm.values,"errors":_vm.errors,"maxLength":"50"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"button-action",on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.newLocation ? 'Add Location' : 'Save Changes'))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3210b4c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/Form.vue
// module id = 632
// module chunks = 0